import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISuspiciousNote, IGetSuspiciousNotesResponse } from "../../api/accounts/index.types";

export interface ISuspiciousCustomersState {
  data: ISuspiciousNote[];
  count: number;
  isLoading: boolean;
}

const initialState: ISuspiciousCustomersState = {
  data: [],
  count: 0,
  isLoading: false,
};

const suspiciousCustomersSlice = createSlice({
  name: "suspiciousCustomers",
  initialState,
  reducers: {
    fetchCustomersRequest: (state) => {
      state.isLoading = true;
    },
    fetchCustomersSuccess: (state, action: PayloadAction<IGetSuspiciousNotesResponse["data"]>) => {
      state.isLoading = false;
      state.data = action.payload.rows;
      state.count = action.payload.count;
    },
    fetchCustomersFailed: (state) => {
      state.isLoading = false;
    },
  },
});

export const suspiciousCustomersActions = suspiciousCustomersSlice.actions;
export default suspiciousCustomersSlice.reducer;
